package com.xtream.data_kmp.db

import androidx.room3.RoomDatabaseConstructor

public actual object AppRoomDBConstructor : RoomDatabaseConstructor<AppRoomDB> {
  override fun initialize(): AppRoomDB = com.xtream.data_kmp.db.AppRoomDB_Impl()
}
